import { useCallback, useRef, useState } from "react";
const useTextOverflow = ()=>{
    const ref = useRef(null);
    const [isOverflowed, setIsOverflowed] = useState(false);
    const checkOverflow = useCallback(()=>{
        const element = ref.current;
        if (element) setIsOverflowed(element.scrollWidth > element.clientWidth);
    }, []);
    return {
        ref,
        checkOverflow,
        isOverflowed
    };
};
export { useTextOverflow };
